import {
    App as AntApp,
    Col,
    Image,
    Row,
    Table,
    Tooltip,
    InputNumber,
    Select,
    Drawer,
    Button,
    List,
    Typography,
    Tag,
    Space,
    Popconfirm,
} from 'antd';
import React, { useState } from 'react';
import { Link, useSearchParams } from "react-router-dom";
import useSwr, { useSWRConfig } from 'swr';
import { zonedTimeToUtc } from 'date-fns-tz';
import UserFeedbackService from '../../../API/UserFeedbackService';
import { getQueryFromPath } from '../../../utils/query';
import { InfoCircleOutlined, EyeOutlined, EditOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const feedbackStatusColorMap = {
    new: 'blue',
    resolved: 'green',
    closed: 'purple',
};

const feedbackSourceTypeColorMap = {
    strapi: 'gold',
    gallery: 'volcano',
};

const PreviewImage = ({ src }) => {
    return (
        <Image
            src={src}
            fallback="data:image/png;base64,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"
            width={25}
            height={25}
            placeholder={true}
        />
    )
}

const LastUpdatedTooltip = ({ imageFeedback }) => {
    if (!imageFeedback || imageFeedback.status === 'new' || !imageFeedback.updated_at) {
        return null;
    }

    return (
        <Tooltip
            title={
                <Space direction="vertical" style={{ padding: 4 }} size={4}>
                    <span>Last Updated:</span>
                    <span>{zonedTimeToUtc(imageFeedback.updated_at).toLocaleString()}</span>
                    <span>{imageFeedback.updated_by}</span>
                </Space>
            }
        >
            <InfoCircleOutlined/>
        </Tooltip>
    );
}

const DrawerContent = ({ imageFeedback }) => {
    if (!imageFeedback || !imageFeedback.feedbacks) {
        return null;
    }

    const { img_url, feedbacks } = imageFeedback;

    const feedbacksGrouped = feedbacks.reduce((accumulator, { reason }) => {
        if (accumulator[reason]) {
            accumulator[reason] += 1;
        }

        if (!accumulator[reason]) {
            accumulator[reason] = 1;
        }

        return accumulator;
    }, {});

    const dataSource = Object.entries(feedbacksGrouped).sort(([_a, a], [_b, b]) => b - a);

    return (
        <>
            <Image
                src={img_url}
                fallback="data:image/png;base64,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"
                preview={false}
                style={{ maxHeight: 330, objectFit: 'contain' }}
                wrapperStyle={{ width: '100%', marginBottom: 24 }}
            />
            <Title level={4}>Reasons</Title>
            <List
                size="small"
                dataSource={dataSource}
                renderItem={([reason, count]) => (
                    <List.Item
                        justify="space-between"
                        style={{ paddingLeft: 0, paddingRight: 0, gap: 16 }}
                    >
                        <Text>{reason}</Text>
                        { count > 1 && <Text>({ count })</Text> }
                    </List.Item>
                )}
            />
        </>
    )
}

const ConfirmStatusChangeButton = ({ imageFeedback, handleConfirm }) => {
    if (!imageFeedback || imageFeedback.status !== 'new') {
        return null;
    }

    const isStrapiSourceType = imageFeedback.source_type === 'strapi';

    return (
        <Popconfirm
            title="Confirm Status Change"
            description={ isStrapiSourceType
                ? 'You need to replace this image in Strapi.'
                : 'Are you sure you want to hide this image?'
            }
            okText={ isStrapiSourceType ? 'Resolve' : 'Hide' }
            cancelText="Cancel"
            placement="topLeft"
            onConfirm={handleConfirm}
        >
            <Button>{ isStrapiSourceType ? 'Resolve' : 'Hide' } <EditOutlined /></Button>
        </Popconfirm>
    );
}

export async function fetcher(url) {
    const query = getQueryFromPath(url);

    const { data } = await UserFeedbackService.getAllGroupedByUrl({
        limit: query.limit || 10,
        offset: query.offset || 0,
        url: query.url || undefined,
        status: query.status === 'all' ? undefined : query.status || 'new',
        filter_type_good_gte: query.statsGood || undefined,
        filter_type_bad_gte: query.statsBad || undefined,
        filter_type_wrong_gte: query.statsWrong || undefined,
        filter_type_other_gte: query.statsOther || undefined,
    })

    return data;
}

const UserFeedbackTable = () => {
    let [searchParams, setSearchParams] = useSearchParams();
    const [drawerFeedbackItem, setDrawerFeedbackItem] = useState();
    const { mutate } = useSWRConfig();
    const { message } = AntApp.useApp();

    const patchSearchParams = (newParams = {}) => {
        setSearchParams((searchParams) => {
            const prevParams = {};
            searchParams.forEach((value, key) => {
                prevParams[key] = value;
            });

            for (const key in newParams) {
                if (newParams[key] === undefined || newParams[key] === null) {
                    delete newParams[key];
                    delete prevParams[key];
                }
            }

            return { ...prevParams, ...newParams };
        });
    };

    const { data, error, loading } = useSwr(`/api/user_feedbacks/grouped_by_url?${searchParams.toString()}`, fetcher, {
        revalidateOnReconnect: false,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        keepPreviousData: true,
    });

    const paginationParams = {
        current: (data?.offset / data?.limit + 1) || 1,
        pageSize: data?.limit || 10,
        total: data?.count,
    }

    const handleTableChange = (pagination, filters, sorter) => {
        patchSearchParams({
            limit: pagination.pageSize,
            offset: (pagination.current - 1) * pagination.pageSize,
            // TODO add sorting
            // sorter: sorter.field,
            // order: sorter.order
        });
    };

    const handleClearFilters = () => {
        patchSearchParams({
            offset: 0,
            status: undefined,
            statsGood: undefined,
            statsBad: undefined,
            statsWrong: undefined,
            statsOther: undefined,
        })
    }

    const handleUpdateFilters = (key, value) => {
        patchSearchParams({
            [key]: value,
            offset: 0,
        });
    }

    const changeImageStatus = async (image, status) => {
        try {
            await UserFeedbackService.changeImageStatus(image, status);

            await mutate(`/api/user_feedbacks/grouped_by_url?${searchParams.toString()}`);
        } catch (e) {
            message.error(e.message)
        }
    }

    const renderStatsFilter = (statsKey, labelAddon) => {
        const value = searchParams.get(statsKey) || null

        return (
            <InputNumber
                key={statsKey}
                min={0}
                value={value}
                addonBefore={labelAddon}
                style={{ width: 160 }}
                onChange={(v) => handleUpdateFilters(statsKey, v)}
            />
        )
    }

    const columns = [
        {
            title: 'Image',
            dataIndex: 'img_url',
            key: 'img_url',
            render: (_text, record) => <PreviewImage src={record.img_url} />,
            width: '60px',
        },
        {
            title: 'Plant ID',
            key: 'plant_id',
            render: (_text, { feedbacks }) => {
                if (!feedbacks || !feedbacks.length) {
                    return '-'
                }

                return (
                    <Link
                        target="_blank"
                        to={feedbacks[0].plantin_plant_page_url}
                        rel="noreferrer"
                    >
                        {feedbacks[0].plant_id}
                    </Link>
                );
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, record) => (
                <Space style={{ width: '100%', justifyContent: 'space-between' }}>
                    <Tag color={feedbackStatusColorMap[text] ?? 'default'}>{text}</Tag>
                    <LastUpdatedTooltip imageFeedback={record}/>
                </Space>
            ),
        },
        {
            title: 'Source Type',
            dataIndex: 'source_type',
            key: 'source_type',
            render: (text) => (
                <Tag color={feedbackSourceTypeColorMap[text] ?? 'default'}>{text}</Tag>
            ),
        },
        {
            title: 'Good Stats',
            dataIndex: 'stats_cnt_good',
            key: 'stats_cnt_good',
        },
        {
            title: 'Bad Stats',
            dataIndex: 'stats_cnt_bad',
            key: 'stats_cnt_bad',
        },
        {
            title: 'Wrong Stats',
            dataIndex: 'stats_cnt_wrong',
            key: 'stats_cnt_wrong',
        },
        {
            title: 'Other Stats',
            dataIndex: 'stats_cnt_other',
            key: 'stats_cnt_other',
        },
        {
            title: 'Last Feedback',
            key: 'last_feedback',
            render: (_text, { feedbacks }) => {
                if (!feedbacks || !feedbacks.length) {
                    return '-'
                }

                return zonedTimeToUtc(feedbacks[feedbacks.length - 1].created_at).toLocaleString();
            }
        },
        {
            title: 'Actions',
            key: 'actions',
            width: '240px',
            render: (_text, record) => (
                <Space>
                    <Button onClick={() => setDrawerFeedbackItem(record)}>
                        View <EyeOutlined/>
                    </Button>
                    <ConfirmStatusChangeButton
                        imageFeedback={record}
                        handleConfirm={() => changeImageStatus(record.img_url, 'resolved')}
                    />
                </Space>
            ),
        },
    ];

    return (
        <>
            <Row style={{ marginBottom: 24, gap: 24 }}>
                <Button onClick={handleClearFilters}>Clear Filters</Button>
                <Select
                    placeholder="Status"
                    style={{ width: 160 }}
                    value={searchParams.get('status') || 'new'}
                    onChange={(v) => handleUpdateFilters('status', v)}
                    options={[
                        { value: 'new', label: 'New' },
                        { value: 'resolved', label: 'Resolved' },
                        { value: 'closed', label: 'Closed' },
                        { value: 'all', label: 'Show All'}
                    ]}
                />
                { renderStatsFilter('statsGood', 'Good >=') }
                { renderStatsFilter('statsBad', 'Bad >=') }
                { renderStatsFilter('statsWrong', 'Wrong >=') }
                { renderStatsFilter('statsOther', 'Other >=') }
            </Row>
            <Row>
                <Col span={24}>
                    <Table
                        rowKey={(record) => `key-${record.id}`}
                        dataSource={data?.results}
                        columns={columns}
                        loading={loading}
                        pagination={paginationParams}
                        scroll={{ x: 'auto' }}
                        onChange={handleTableChange}
                    />
                </Col>
            </Row>
            <Drawer
                title="Image Feedback"
                open={!!drawerFeedbackItem}
                onClose={() => setDrawerFeedbackItem(null)}
            >
                <DrawerContent imageFeedback={drawerFeedbackItem}/>
            </Drawer>
        </>
    );
};

const UserFeedbacks = () => {
    return <UserFeedbackTable />
};

export default UserFeedbacks;
